var _excluded = ["selectedItems", "isOpen", "getComboboxProps", "openMenu"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { MultiControl, Selected, SearchInput, Placeholder } from '../layout';

var MultiAutocompleteControl = function MultiAutocompleteControl(_ref) {
  var selectedItems = _ref.selectedItems,
      isOpen = _ref.isOpen,
      _getComboboxProps = _ref.getComboboxProps,
      openMenu = _ref.openMenu,
      props = _objectWithoutProperties(_ref, _excluded);

  var shouldShowPlaceholder = !isOpen && (!selectedItems || !selectedItems.length);
  return /*#__PURE__*/React.createElement(MultiControl, _extends({
    selectedItems: selectedItems,
    isOpen: isOpen,
    getComboboxProps: function getComboboxProps() {
      return _getComboboxProps({
        style: {
          flex: 1,
          display: 'flex',
          maxWidth: isOpen ? 'unset' : 0,
          opacity: isOpen ? 1 : 0
        }
      });
    },
    renderItems: function renderItems(_ref2) {
      var itemToString = _ref2.itemToString;
      return !isOpen && /*#__PURE__*/React.createElement(Selected, {
        selectedItems: selectedItems,
        itemToString: itemToString
      });
    },
    renderInput: function renderInput(inputProps) {
      return /*#__PURE__*/React.createElement(SearchInput, inputProps);
    },
    renderPlaceholder: function renderPlaceholder() {
      return shouldShowPlaceholder && /*#__PURE__*/React.createElement(Placeholder, null);
    },
    onClick: openMenu
  }, props));
};

MultiAutocompleteControl.displayName = 'MultiAutocompleteControl';
MultiAutocompleteControl.propTypes = {
  /** Function to open menu.  Provided by useMultiAutocomplete hook */
  openMenu: PropTypes.func.isRequired
};
export default MultiAutocompleteControl;
//# sourceMappingURL=MultiAutocompleteControl.js.map